<template>
  <v-card v-bind="$attrs" class="tj-facet">
    <v-expansion-panels v-model="panel" flat accordion v-bind="$attrs">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <template v-slot:default="{ open }">
            <div class="d-flex align-center">
              <span class="text-subtitle-2 mr-2">{{ titulo }}</span>
              <span v-if="!open && hasActiveFilters">
                <v-icon color="primary" small>mdi-check-circle</v-icon>
              </span>
            </div>
          </template>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <div v-for="item in itens" :key="item.key" class="d-flex mb-1">
            <v-checkbox
              v-model="item.checked"
              class="my-0 pt-0"
              dense
              hide-details
              @change="onCheckChange(item)"
            ></v-checkbox>
            <span class="is-caption flex-grow-1 mx-0 my-1 pt-1">
              {{ item.text }}
            </span>
            <span
              class="is-caption text-right my-1"
              style="display:inline-box; width:6em;"
            >
              {{ item.count }}
            </span>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import Vue from "vue";

export default Vue.component("tj-facet", {
  props: {
    titulo: String,
    itens: Array,
    chave: String,
    closed: Boolean
  },

  data() {
    return {
      refPanel: this.panel
    };
  },

  computed: {
    panel:{
      get() {
        return this.closed? null: 0
      },
      set(v) {
        this.$emit("closed", v !== 0)        
      }
    },

    selectedItens(){
      return this.loadSelection(this.itens)
    },

    hasActiveFilters() {
      return this.selectedItens.length > 0;
    }

  },


  methods: {

    onCheckChange(item) {
      //this.selectedItens = this.loadSelection(this.itens);
      this.$emit("selection", {
        key: this.chave,
        value: item.key,
        state: item.checked
      });
    },

    loadSelection(itens) {
      return itens.filter(v => v.checked).map(v => v.key);
    },

  }
});
</script>

<style>
.tj-facet .v-expansion-panel-content__wrap {
  padding: 0 6px 8px;
}

.tj-facet .v-expansion-panel-header {
  padding: 6px 8px;
}

.tj-facet .is-caption {
  font-size: 0.6rem !important;
  text-transform: uppercase;
  line-height: 1.2;
}
</style>
